import { CardContent, Grid, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'
import DefaultImage from '../../assets/No-Image.png'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import moment from 'moment-timezone'
import LanguageStrings from '../../i18n/locales'

const ManagementInfoHeader = (props: AllProps): JSX.Element => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const AssetInformationStrings = LanguageStrings().GatewayManagementCollectionStrings.AssetInformationComponent
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 40) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 40)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : '-'}</span>
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  return (
  <>
    <CardContent style={{ padding: 0 }}>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item>
          <div style={{ padding: '10px', backgroundColor: '#303030', borderRadius: '10px', width: 'fit-content' }}>
            <img
              src={(props.binaryData !== '' && props.binaryData != null) ? `data:image/jpeg;base64,${props.binaryData}` : DefaultImage}
              alt="Preview"
              style={{ width: '136px', height: '136px', objectFit: 'cover', borderRadius: '8px' }}
            />
          </div>
        </Grid>
        <Grid item xs>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Typography variant="subtitle1" fontWeight={600} fontSize="small">
                {props.title}
              </Typography>
            </Grid>
            <Grid item container spacing={2} alignItems="flex-start">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography fontWeight="bold">{AssetInformationStrings.Name}</Typography>
                <div>{formatTextWithTooltip(props?.name)}</div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography fontWeight="bold">{AssetInformationStrings.CreatedOn}</Typography>
                <div>
                  {(props?.createdOn !== '' && props?.createdOn != null) && moment.utc(props?.createdOn).tz(userTimezone).format('hh:mm A, MMM DD YYYY')}
                </div>
              </Grid>
              <Grid item xs={11} md={11} lg={5}>
                <Typography fontWeight="bold">{AssetInformationStrings.Description}</Typography>
                <div style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>{props?.description}</div>
              </Grid>
              <Grid item xs={1} md={1} lg={1} >
                <IconButton
                  aria-haspopup="true"
                  aria-controls={open ? 'fade-menu' : undefined}
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                  sx={{ padding: '0px !important' }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="fade-menu"
                  MenuListProps={{ 'aria-labelledby': 'fade-button' }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem onClick={() => { handleClose(); props.handleEdit() }} style={{ color: '#64c3ff', textDecoration: 'none' }}>Edit</MenuItem>
                  <MenuItem onClick={() => { handleClose(); props.handleDelete() }} style={{ color: '#64c3ff', textDecoration: 'none' }}>Delete</MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </CardContent>
  </>)
}

interface InputProps {
  title: string
  binaryData: string
  name: string
  createdOn: string
  description: string
  handleEdit: any
  handleDelete: any
}
type AllProps = InputProps
export const MemoManagementInfoHeader = React.memo(ManagementInfoHeader)
